module.exports = __webpack_public_path__ + "static/media/harm-kay-text.35bfcedc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-banner/harm-kay-text.png
// module id = 56
// module chunks = 0